/**
 * Create media query objects
 * @param breakpoints the list of configured breakpoint names and their pixel values
 */
var createMediaQueries = function createMediaQueries(breakpoints) {
  var sortedBreakpoints = Object.keys(breakpoints).sort(function (a, b) {
    return breakpoints[b] - breakpoints[a];
  });
  return sortedBreakpoints.map(function (breakpoint, index) {
    var query = '';
    var minWidth = breakpoints[breakpoint];
    var nextBreakpoint = sortedBreakpoints[index - 1];
    var maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] : null;

    if (minWidth >= 0) {
      query = "(min-width: ".concat(minWidth, "px)");
    }

    if (maxWidth !== null) {
      if (query) {
        query += ' and ';
      }

      query += "(max-width: ".concat(maxWidth - 1, "px)");
    }

    var mediaQuery = {
      breakpoint: breakpoint,
      maxWidth: maxWidth ? maxWidth - 1 : null,
      minWidth: minWidth,
      query: query
    };
    return mediaQuery;
  });
};

export default createMediaQueries;